//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {}
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '该问卷暂未发布，你确定要发布吗？',
    },
  },
  computed: {},
  methods: {
    submit() {
      this.$emit('onrelease')
      this.$emit('popup-close')
    },
    cancle() {
      this.$emit('popup-close')
    },
  },
}
